"use client";

import {
  PageNavMenu,
  PageNavMenuTheme,
} from "@punchup/ui-common/components/common";
import { VenuePageCustomLink, VenuePageExternalLink } from "../../../data";
import {
  getBasePath,
  toPageNavMenuLinks,
  type ComputedNavItem,
  type VenuePageUrlBase,
} from "./utils";

import { VenuePageEvents, trackEvent } from "@punchup/analytics";

export interface VenuePageNavProps {
  venueSlug: string;
  navItems: ComputedNavItem[];
  customLinks: VenuePageCustomLink[];
  externalLinks: VenuePageExternalLink[];
  urlBase: VenuePageUrlBase;
  theme?: PageNavMenuTheme;
  className?: string;
}

const defaultTheme: PageNavMenuTheme = {
  textColor: "#787b7e", // secondary blue
  borderColor: "#C7C8C9",
  activeTextColor: "#29333c", // primary blue
  activeBorderColor: "#29333c", // primary blue
};

export default function VenuePageNav({
  venueSlug,
  navItems,
  customLinks,
  externalLinks,
  urlBase,
  theme = defaultTheme,
  className,
}: VenuePageNavProps) {
  const allLinks = toPageNavMenuLinks(navItems);

  const handleLinkClick = (link: {
    label: string;
    href: string;
    type?: "internal" | "external";
  }) => {
    const navItem = navItems.find((item) => item.href === link.href);

    if (link.type === "external" || navItem?.itemType === "external") {
      const originalLink = externalLinks.find((el) => el.url === link.href);
      if (originalLink) {
        trackEvent(VenuePageEvents.CLICKED_EXTERNAL_LINK, {
          venueSlug,
          ...originalLink,
        });
      }
    } else if (navItem?.itemType === "custom") {
      const basePath = getBasePath(urlBase, venueSlug);
      const originalCustomLink = customLinks.find(
        (cl) => `${basePath}/${cl.path}` === link.href
      );
      if (originalCustomLink) {
        trackEvent(VenuePageEvents.CLICKED_CUSTOM_INTERNAL_LINK, {
          venueSlug,
          ...originalCustomLink,
        });
      }
    } else {
      trackEvent(VenuePageEvents.CLICKED_INTERNAL_LINK, {
        venueSlug,
        ...link,
      });
    }
  };

  const handleViewMoreClick = () => {
    trackEvent(VenuePageEvents.CLICKED_VIEW_MORE_NAV_MENU, {
      venueSlug,
    });
  };
  return (
    <PageNavMenu
      links={allLinks}
      theme={theme}
      className={className}
      onLinkClick={handleLinkClick}
      onViewMoreClick={handleViewMoreClick}
      footerLink={{
        label: "Go to Punchup",
        href: "https://punchup.live/",
      }}
      horizontalSpacer
    />
  );
}
